import { SUPPORT_TELEGRAM_URL } from '@upme/view-logic';
import { useTranslation } from 'react-i18next';

export interface SupportContactBlockProps {
  className?: string;
}

/** Текст + ссылка «написать администратору» со просьбой прислать скриншот. */
export function SupportContactBlock({ className }: SupportContactBlockProps) {
  const { t } = useTranslation('shared');
  return (
    <div className={className}>
      <p className="whitespace-pre-line text-sm text-muted-foreground">{t('support.contactAdmin')}</p>
      <a
        href={SUPPORT_TELEGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 inline-block text-sm font-medium underline"
      >
        {t('support.writeUs')}
      </a>
    </div>
  );
}
